import { render } from "./VendorsManager.vue?vue&type=template&id=2d94eddf&lang=pug"
import script from "./VendorsManager.vue?vue&type=script&lang=ts"
export * from "./VendorsManager.vue?vue&type=script&lang=ts"
script.render = render

export default script